import { useCallback, useContext, useEffect, useState } from "react"
import { useInput } from "./useInput"
import { useTranslation } from "react-i18next"
import { Item } from "../../../../../utils/types/generals"
import { GlobalContext } from "../../../../../contexts/Global"
import { canAccess } from "../../../../../utils/validate/canaccess"
import { Roles, Status } from "../../../../../utils/enums"
import { getArea, getDepartments, getDivisions, getStore, getUsers, getUserTypes, getZones } from "../../../../../utils/methods/geServiceWithItemsFormat"
import { getUserRole } from "../../../../../service/auth"
import { getStatus } from "../../../../../hooks/status"


const useGetData = ({counter,cleanFilter,getExecutionDetalData, queryv2, lastVersionId, getVersionQuestionaire, sections, applyQuestionFilter, onChange, resetQuestionFilter }:{counter:number | null,cleanFilter: () => void,getExecutionDetalData: (idversion:string, query?:string) => Promise<void>,queryv2:string,lastVersionId:string, getVersionQuestionaire:(query?:string) => Promise<void>, sections?: any[], applyQuestionFilter: () => void, onChange?: (e: any) => void, resetQuestionFilter?: () => void }) => {
  const [items, setItems] = useState<{ [x: string]: Item[] }>({})
  const [childZones, setChildZones] = useState<any[]>([])
  const [departments, setDepartments] = useState<any[]>([])
  const { input, disabledInputs } = useInput({ items, counter, cleanFilter, getExecutionDetalData,queryv2,lastVersionId, getVersionQuestionaire, applyQuestionFilter, onChange, resetQuestionFilter })
  const { t } = useTranslation()
  const { colors } = useContext(GlobalContext)
  
  const handleItemsByExternal = ({ name, value }: { name: string; value: any }) => {
    setItems((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const getData = useCallback(async () => {

    getUserTypesService()
    getDivisionsService()
    getUsersService()
    // getAreasService()
    // getDepartmentService()
    getStoreService()
    getZonesService()
    getItemStatus()

    // setLoadingTable(false)
  }, [])

  const getStoreService = async () => {
    const { items } = await getStore()

    setItems((prev) => ({
      ...prev,
      keyCodeId: items,
    }))
  }

  const getAreasService = async () => {
    const responseAreas = await getArea()
    
    setItems((prev) => ({
      ...prev,
      areas: responseAreas,
    }))
  }

  const getDepartmentService = async () => {
    const departments = await getDepartments()
    setDepartments(departments)
  }

  const getItemStatus = async () => {
      const statusList = [Status.TO_BE_STARTED, Status.STARTED, Status.PAUSE, Status.EXPIRED, Status.NOT_FINISHED, Status.FINISHED, Status.CANCEL, Status.CLOSE, Status.WAITING]
  
      setItems((prev) => ({
        ...prev,
        status: statusList.map((item) => {
          const status = getStatus(item, colors, t)
          return {
            label: /* status.value == Status.CLOSE ? t(`general.status.cancel`) : */ status.text,
            value: status.value,
          }
        }),
      }))
    }

  const getZonesService = async () => {
    const { childZones, fatherZones } = await getZones()

    setChildZones(childZones)
    setItems((prev) => ({
      ...prev,
      zoneId: fatherZones,
    }))
  }

  const getUserTypesService = async () => {
    const { items } = await getUserTypes()

    setItems((prev) => ({
      ...prev,
      userTypeId: items,
    }))
  }

  const getUsersService = async () => {
    // const role = getUserRole()
    // if (role === Roles.AGENT) return
    const { items } = await getUsers()

    setItems((prev) => ({
      ...prev,
      userId: items,
    }))
  }

  const getDivisionsService = async () => {
    const division = await getDivisions()

    setItems((prev) => ({
      ...prev,
      divisions: division.items,
    }))
  }

  useEffect(() => {
    setItems((prev) => ({
      ...prev,
      answerType: [
        {label: 'Correctas', value: 'corrects'},
        {label: 'Incorrectas', value: 'incorrects'},
      ],
    }))
  }, [])

  useEffect(() => {
    
    if (sections && sections.length > 0) {
      const questionTitles: { label: string; value: string }[] = []
      sections.forEach((section, sectionIndex) => {
        section.questions?.forEach((question: any, questionIndex: number) => {
          questionTitles.push({
            label: question.title,
            value: `${sectionIndex}-${questionIndex}`
          })
        })
      })
      setItems((prev) => ({
        ...prev,
        questions: questionTitles,
      }))
    } else {
      setItems((prev) => ({
        ...prev,
        questions: [],
      }))
    }
  }, [sections])


  return { items, departments, childZones, input, getData, handleItemsByExternal, disabledInputs }
}

export { useGetData }